import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PickingJobsOverviewQueryVariables = Types.Exact<{
  item_location_id?: Types.InputMaybe<Types.Scalars['UUID']>;
  pickup_date_from?: Types.InputMaybe<Types.Scalars['String']>;
  pickup_date_to?: Types.InputMaybe<Types.Scalars['String']>;
  statuses?: Types.InputMaybe<Array<Types.PickingJobStatus> | Types.PickingJobStatus>;
  picked_item_search?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type PickingJobsOverviewQuery = { __typename?: 'Query', getPickingJobs: Array<{ __typename?: 'PickingJobListItem', id: string, segment: Types.PickingJobSegment, status: Types.PickingJobStatus, carrier_pickup_date?: string | null, total_amount_ordered: number, total_amount_picked: number, destination: { __typename?: 'PickingJobDestination', partner_name?: string | null, event?: { __typename?: 'PickingJobEvent', id: string, name?: string | null } | null, drop_off_location?: { __typename?: 'IdName', id: string, name: string } | null } }> };


export const PickingJobsOverviewDocument = gql`
    query PickingJobsOverview($item_location_id: UUID, $pickup_date_from: String, $pickup_date_to: String, $statuses: [PickingJobStatus!], $picked_item_search: String) {
  getPickingJobs(
    item_location_id: $item_location_id
    pickup_date_from: $pickup_date_from
    pickup_date_to: $pickup_date_to
    statuses: $statuses
    picked_item_search: $picked_item_search
  ) {
    id
    segment
    status
    carrier_pickup_date
    total_amount_ordered
    total_amount_picked
    destination {
      event {
        id
        name
      }
      partner_name
      drop_off_location {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePickingJobsOverviewQuery__
 *
 * To run a query within a React component, call `usePickingJobsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickingJobsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickingJobsOverviewQuery({
 *   variables: {
 *      item_location_id: // value for 'item_location_id'
 *      pickup_date_from: // value for 'pickup_date_from'
 *      pickup_date_to: // value for 'pickup_date_to'
 *      statuses: // value for 'statuses'
 *      picked_item_search: // value for 'picked_item_search'
 *   },
 * });
 */
export function usePickingJobsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<PickingJobsOverviewQuery, PickingJobsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickingJobsOverviewQuery, PickingJobsOverviewQueryVariables>(PickingJobsOverviewDocument, options);
      }
export function usePickingJobsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickingJobsOverviewQuery, PickingJobsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickingJobsOverviewQuery, PickingJobsOverviewQueryVariables>(PickingJobsOverviewDocument, options);
        }
export type PickingJobsOverviewQueryHookResult = ReturnType<typeof usePickingJobsOverviewQuery>;
export type PickingJobsOverviewLazyQueryHookResult = ReturnType<typeof usePickingJobsOverviewLazyQuery>;
export type PickingJobsOverviewQueryResult = Apollo.QueryResult<PickingJobsOverviewQuery, PickingJobsOverviewQueryVariables>;